<template>
    <div id="CedesOverview">
        <cedes-quicktable />
    </div>
</template>

<script>
import cedesQuicktable from './Cedes/quicktable.vue'
export default {
    name: 'Cedes',
    components: {cedesQuicktable}
}
</script>